export const onEnter =
  (callback: (event: React.KeyboardEvent) => void) => (event: React.KeyboardEvent) => {
    event.code === 'Enter' && callback(event)
  }
